import type {Pointer, PS} from '@wix/document-services-types'
import component from '../../component/component'

export default function (ps: PS, compPointer: Pointer) {
    const compProps = component.properties.get(ps, compPointer) || {}
    compProps.metaData = compProps.metaData || {}
    compProps.metaData.schemaVersion = '2.0'
    component.properties.update(ps, compPointer, compProps)
}
